// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ba873cb","455":"d38acbc6"}[chunkId] + ".chunk.js";
};